import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Team from '../images/team_work_trying_to_cut1.jpg';
import Team1 from '../images/Car.jpg';
import Life1 from '../images/Damac.jpg';
import Life2 from '../images/vibranum.jpg';
import Life3 from '../images/TCF.png';
import Life4 from '../images/Alshafi.jpg';
import mh from '../images/m.jpg';

import Ah from '../images/Ah.jpg';


import { useLanguage } from "../pages/LanguageContext";
import {
  FaUsers,
  FaQuoteLeft,
  FaBriefcase,
  FaExclamationTriangle,
  FaLinkedin,
  FaGraduationCap,
  FaHandsHelping,
  FaDatabase,
  FaBell,
} from "react-icons/fa";

// ============ TRANSLATIONS ============
const translations = {
  en: {
    pageTitle: "Careers at Mass Smart Solutions",
    pageSubtitle: "Revolutionizing Spaces. Empowering People. We’re shaping the future of smart living — and it starts with the right team.",
    lifeTitle: <> <FaUsers style={{ marginRight: "7px" }} /> Life at Mass Smart Solutions </>,
    lifeText: "We’re not just engineers and technicians — we’re visionaries, creators, and smart home pioneers.",
    lifePhotos: [Life1, Life2, Life3, Life4],
    lifeDesc: (
      <>
        <span style={{ color: "#1a4bb7", fontWeight: 800, fontSize: "1.13rem" }}>
          Work. Grow. Celebrate.
        </span>
        <br />
        At Mass, our people are family—curious, creative, and always connected.
      </>
    ),
    missionTitle: "Our Mission",
    missionText: "To make smart living seamless, intuitive, and accessible for every home.",
    valuesTitle: "Our Core Values",
    valuesText: "🔧 Innovation | 👥 Integrity | 🚀 Growth | 🧠 Customer-Centric Thinking",
    meetTeam: "Meet Our Team",
    teamMembers: [
      {
        name: "Mohammed",
        title: "Project Engineer",
        img: mh,
        quote: "We help turn houses into smart experiences , and that’s something I’m proud of."
      },
      {
        name: "Ahmad",
        title: "Automation Support Engineer",
        img: Ah,
        quote: "Designing intuitive experiences that simplify lives , that’s what drives me."
      },
    ],
    departmentsHeader: "Departments We Hire For",
    departments: [
      {
        icon: <FaGraduationCap className="depart-icon" />,
        title: "Technical & Operations",
        text: "Smart Home Engineering & R&D, Network & IT Infrastructure, Project Execution & Field Installation, Automation Support & System Calibration."
      },
      {
        icon: <FaDatabase className="depart-icon" />,
        title: "Business & Admin",
        text: "Accounting & Finance, HR & Recruitment, Procurement & Supply Chain Management, Executive Admin."
      },
      {
        icon: <FaBell className="depart-icon" />,
        title: "Sales & Marketing",
        text: "B2C/B2B Smart Home Sales, Digital Marketing, Business Development, Customer Engagement."
      },
    ],
    notHiring: "We're Not Hiring Right Now",
    notHiringText: <>But we’d love to hear from you. Email your CV to <a href="mailto:careers@we-mass.com">careers@we-mass.com</a></>,
    internshipsHeader: "Internships Programs",
    internships: [
      {
        icon: <FaHandsHelping className="opportunity-icon" />,
        title: "Open to Students & Grads",
        text: <>Tech, R&D, Admin internships — email <a href="mailto:internships@we-mass.com">internships@we-mass.com</a></>
      },
      {
        icon: <FaBriefcase className="opportunity-icon" />,
        title: "Project-Based",
        text: "Gain experience through field assignments."
      },
      {
        icon: <FaGraduationCap className="opportunity-icon" />,
        title: "Mentorship",
        text: "Grow with guidance from senior engineers and business experts."
      },
    ],
    stayConnected: <> <FaLinkedin /> Stay Connected </>,
    stayConnectedText: "Follow us on LinkedIn for openings and updates from the Mass Smart Solutions family.",
    followUs: "Follow Us on LinkedIn",
  },
  ar: {
    pageTitle: "الوظائف في ماس سمارت سوليوشنز",
    pageSubtitle: "نُحدث ثورة في المساحات. نُمكّن الأشخاص. نحن نشكّل مستقبل المنازل الذكية — والبداية مع الفريق المناسب.",
    lifeTitle: <> <FaUsers style={{ marginRight: "7px" }} /> الحياة في ماس سمارت سوليوشنز </>,
    lifeText: "لسنا مجرد مهندسين وفنيين — نحن مبدعون، صانعو مستقبل المنازل الذكية.",
    lifePhotos: [Life1, Life2, Life3, Life4],
    lifeDesc: (
      <>
        <span style={{ color: "#1a4bb7", fontWeight: 800, fontSize: "1.13rem" }}>
          نعمل. ننمو. نحتفل.
        </span>
        <br />
        في ماس، موظفونا عائلة—فضوليون، مبدعون، ومتواصلون دائمًا.
      </>
    ),
    missionTitle: "مهمتنا",
    missionText: "نجعل العيش الذكي سهلاً وبديهياً وفي متناول الجميع.",
    valuesTitle: "قيمنا الأساسية",
    valuesText: "🔧 الابتكار | 👥 النزاهة | 🚀 التطور | 🧠 التفكير بمنظور العميل",
    meetTeam: "تعرف على فريقنا",
    teamMembers: [
      {
        name: "محمد",
        title: "مهندس مشاريع",
        img: mh,
        quote: "نساعد في تحويل المنازل إلى تجارب ذكية , وهذا مصدر فخر لي"
      },
      {
        name: "احمد",
        title: "مهندس دعم الأتمتة",
        img: Ah,
        quote: "تصميم تجارب سهلة تبسط الحياة, هذا ما يحفزني"
      },
    ],
    departmentsHeader: "الأقسام التي نوظف لها",
    departments: [
      {
        icon: <FaGraduationCap className="depart-icon" />,
        title: "القسم الفني والتشغيل",
        text: "هندسة المنازل الذكية والبحث والتطوير، الشبكات والبنية التحتية، تنفيذ المشاريع والتركيب الميداني، دعم الأتمتة ومعايرة الأنظمة."
      },
      {
        icon: <FaDatabase className="depart-icon" />,
        title: "الأعمال والإدارة",
        text: "المحاسبة والمالية، الموارد البشرية والتوظيف، المشتريات وإدارة سلسلة التوريد، الإدارة التنفيذية."
      },
      {
        icon: <FaBell className="depart-icon" />,
        title: "المبيعات والتسويق",
        text: "مبيعات المنازل الذكية للأفراد والشركات، التسويق الرقمي، تطوير الأعمال، خدمة العملاء."
      },
    ],
    notHiring: "لا توجد وظائف متاحة حالياً",
    notHiringText: <>لكن يسعدنا استقبال سيرتك الذاتية. أرسلها إلى <a href="mailto:careers@we-mass.com">careers@we-mass.com</a></>,
    internshipsHeader: "برامج التدريب",
    internships: [
      {
        icon: <FaHandsHelping className="opportunity-icon" />,
        title: "مفتوحة للطلاب والخريجين",
        text: <>تدريبات في التقنية، البحث والتطوير، الإدارة — أرسل إلى <a href="mailto:internships@we-mass.com">internships@we-mass.com</a></>
      },
      {
        icon: <FaBriefcase className="opportunity-icon" />,
        title: "مشاريع تطبيقية",
        text: "اكتسب الخبرة من خلال المهام الميدانية."
      },
      {
        icon: <FaGraduationCap className="opportunity-icon" />,
        title: "إرشاد وتوجيه",
        text: "تطور مع خبرة مهندسينا وخبراء الأعمال."
      },
    ],
    stayConnected: <> <FaLinkedin /> ابقَ على تواصل </>,
    stayConnectedText: "تابعنا على لينكدإن لتعرف عن الوظائف وآخر أخبار فريق ماس سمارت سوليوشنز.",
    followUs: "تابعنا على لينكدإن",
  }
};

const blueHeader = "#2297e6";

const CareerPage = () => {
  const { language } = useLanguage();
  const t = translations[language] || translations.en;
  const isAr = language === 'ar';

  const sectionHeaderStyle = {
    fontSize: "1.4rem",
    fontWeight: "600",
    marginBottom: "1rem",
    borderBottom: "2px solid #dce1f5",
    paddingBottom: "0.5rem",
    display: "inline-block",
  };

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <>
      <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&family=Cairo:wght@400;700&display=swap" rel="stylesheet" />
      <style>{`
        html, body, #root, .App, .career-page-gradient { max-width: 100vw !important; overflow-x: hidden !important; }
        body { font-family: Inter, 'Cairo', 'Tajawal', Arial, sans-serif; }
        .career-page-gradient h1, .career-page-gradient h2, .career-page-gradient h3, .career-page-gradient h4, .career-page-gradient h5, .career-page-gradient h6, 
        .career-page-gradient .logo-gradient-text, .career-page-gradient .blue-text, .career-page-gradient .heading-blue, .career-page-gradient .glass-icon, 
        .career-page-gradient .depart-icon, .career-page-gradient .opportunity-icon {
          background: linear-gradient(90deg, #1784e6 0%, #1a4bb7 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          color: #1784e6;
          font-weight: 700;
        }
        /* ==== Departments header: always blue, not gradient ==== */
        .departments-cards-header {
          font-size: 1.52rem;
          font-weight: 800;
          margin-bottom: 2.1rem;
          letter-spacing: 0.01em;
          text-align: center;
          color: #2297e6 !important;
          background: none !important;
          -webkit-background-clip: unset !important;
          -webkit-text-fill-color: unset !important;
          background-clip: unset !important;
        }
        /* ==== DARK MODE: ALL DEEP DARK, WHITE TEXT, HEADER BLUE ==== */
        body.dark, .dark {
          background:#111 !important;
          color: #fff !important;
        }
        .dark .career-page-gradient, 
        .dark .career, 
        .dark .content-wrapper, 
        .dark .career-hero, 
        .dark .career-hero-left,
        .dark .career-hero-right,
        .dark .life-section,
        .dark .departments-cards-section,
        .dark .life-mass-card,
        .dark .departments-card,
        .dark .quote-card,
        .dark .opportunity-card,
        .dark .not-hiring-box,
        .dark .stay-connected,
        .dark .life-mass-desc {
          background:#111 !important;
          color: #fff !important;
          border: none !important;
          box-shadow: none !important;
        }
        /* --- Make mass-life-section border white in dark mode --- */
        .mass-life-section {
          background: #fff !important;
          border-top: 2px solid #e2e8f0;
        }
        body.dark .mass-life-section, .dark .mass-life-section {
          background:#111 !important;
          border-top: 2px solid #fff !important;
        }
        /* Make all text white in dark mode */
        .dark .career-page-gradient,
        .dark .career-page-gradient * {
          color: #fff !important;
          background: none !important;
          -webkit-text-fill-color: #fff !important;
        }
        /* Make headers blue in dark mode */
        .dark .career-page-gradient h1,
        .dark .career-page-gradient h2,
        .dark .career-page-gradient h3,
        .dark .career-page-gradient h4,
        .dark .career-page-gradient h5,
        .dark .career-page-gradient h6,
        .dark .departments-cards-header {
          color: ${blueHeader} !important;
          background: none !important;
          -webkit-text-fill-color: ${blueHeader} !important;
        }
        .dark .logo-gradient-text,
        .dark .blue-text,
        .dark .heading-blue,
        .dark .glass-icon,
        .dark .depart-icon,
        .dark .opportunity-icon {
          color: ${blueHeader} !important;
          background: none !important;
          -webkit-text-fill-color: ${blueHeader} !important;
        }
        /* Other dark mode fixes */
        .dark .life-mass-photo { border: 2.3px solid #202e54; background: #232b43; }
        .dark .life-mass-desc { background:#111 !important; color: #fff !important; }
        .dark .stay-btn { border: 1px solid #425182; color: #fff !important; }
        .dark a, .dark a:visited { color: #aee1ff; }
        /* === Make card borders white in dark mode === */
        .dark .life-mass-card,
        .dark .departments-card,
        .dark .opportunity-card {
          border: 1.5px solid #fff !important;
        }
        .dark .not-hiring-box {
          border: 1.5px dashed #fff !important;
        }
        /* === White border for Join Us/Stay Connected in dark mode, gray in light === */
        .stay-connected {
          border: 1.5px solid #e2e8f0;
        }
        .dark .stay-connected {
          border: 1.5px solid #fff !important;
        }
        /* ========== NORMAL STYLES ========== */
        .career {padding: 2rem 1rem 5rem;color: #1a1a1a;}
        .career-hero {width: 100%;background: #ffffff;padding: 4rem 2rem;margin-bottom: 4rem;box-sizing: border-box;}
        .career-hero-content {max-width: 1200px;margin: 0 auto;display: flex;flex-wrap: wrap;justify-content: space-between;align-items: center;gap: 2rem;}
        .career-hero-left {flex: 1;min-width: 280px;position: relative;overflow: visible;z-index: 2;font-size: 1.3rem;}
        .career-hero-left p {font-size: 1.2rem;color: #333;max-width: 540px;}
        .career-hero-right {flex: 1;min-width: 280px;display: flex;justify-content: center;}
        .career-hero-right img {width: 100%;max-width: 480px;border-radius: 24px;}
        .content-wrapper {max-width: 1100px;margin: 0 auto;padding: 0 1rem;}
        .mass-life-section {padding: 4rem 1rem;margin-bottom: 3rem;}
        .mass-life-wrapper {max-width: 1100px;margin: 0 auto;text-align: center;}
        .mass-life-wrapper p {font-size: 1.1rem;color: #444;max-width: 750px;margin: 0 auto 2.5rem;line-height: 1.7;}
        .life-mass-grid {display: flex;flex-direction: column;gap: 2.5rem;align-items: center;justify-content: center;margin-top: 2.3rem;}
        .life-mass-cards {display: flex;gap: 2.3rem;justify-content: center;flex-wrap: wrap;}
        .life-mass-card {background: rgba(255,255,255,0.96);border: 1.5px solid #dce1f5;border-radius: 22px;box-shadow: 0 8px 30px rgba(34,151,230,0.08);padding: 2rem 1.4rem 1.6rem 1.4rem;min-width: 260px;max-width: 340px;transition: transform .21s, box-shadow .21s;text-align: center;display: flex;flex-direction: column;align-items: center;}
        .life-mass-card:hover {transform: translateY(-7px) scale(1.03);box-shadow: 0 16px 48px rgba(26,75,183,0.13);}
        .life-mass-card h4 {margin-bottom: 0.8rem;font-size: 1.15rem;font-weight: 700;}
        .life-mass-card p {color: #3566a7;font-size: 1.03rem;margin: 0;}
        .life-mass-card .glass-icon {font-size: 2.2rem;margin-bottom: 1.1rem;color: #2297e6;}
        .life-mass-photos {display: flex;gap: 1.7rem;flex-wrap: wrap;align-items: center;justify-content: center;margin-top: 0.7rem;}
        .life-mass-photo {width: 135px;height: 105px;object-fit: cover;border-radius: 13px;border: 2.3px solid #2297e64a;box-shadow: 0 4px 18px #2297e615;transition: transform .17s;background: #f6fbff;}
        .life-mass-photo:hover {transform: scale(1.05) rotate(-2deg);box-shadow: 0 8px 28px #2297e627;}
        .life-mass-desc {min-width: 190px;max-width: 235px;color: #2297e6;font-weight: 600;font-size: 1.03rem;text-align: center;background: #f6fbff;padding: 1rem 0.9rem;border-radius: 12px;box-shadow: 0 2px 8px #2297e614;margin-left: 0.7rem;margin-right: 0.7rem;}
        .life-section {margin: 2rem 0 4rem;}
        .life-container {display: flex;flex-wrap: wrap;align-items: center;gap: 2rem;background: #ffffff;padding: 2rem;border-radius: 16px;box-shadow: 0 8px 24px rgba(0,0,0,0.05);border: 1px solid #e4e4e4;width: 100%;box-sizing: border-box;margin: 0;}
        .life-image-box {flex: 1;min-width: 200px;display: flex;justify-content: center;width: 100%;box-sizing: border-box;}
        .image-frame {position: relative;overflow: hidden;border-radius: 20px;border: 2px solid #d3e3fc;box-shadow: 0 12px 32px rgba(0, 0, 0, 0.08);transition: transform 0.3s ease;width: 100%;max-width: 500px;margin: 0 auto;box-sizing: border-box;}
        .image-frame img {display: block;width: 100%;height: auto;object-fit: cover;transition: transform 0.4s ease;}
        .image-frame:hover img {transform: scale(1.03);}
        .life-content {flex: 2;min-width: 200px;width: 100%;box-sizing: border-box;}
        .life-content p {font-size: 1rem;color: #333;max-width: 600px;}
        .quote-card {background: #fff;border-radius: 16px;box-shadow: 0 6px 20px rgba(0, 0, 0, 0.06);padding: 1.25rem;display: flex;align-items: center;gap: 1rem;margin-bottom: 1rem;}
        .quote-card img {width: 50px;height: 50px;border-radius: 50%;object-fit: cover;}
        .departments-cards-section {max-width: 1100px;margin: 0 auto 3rem auto;padding: 2.7rem 1.2rem 1.5rem 1.2rem;background: linear-gradient(130deg, #f5faff 75%, #e4efff 100%);border-radius: 32px;box-shadow: 0 12px 32px 0 rgba(34,151,230,0.10);position: relative;overflow: visible;}
        .departments-cards-row {display: flex;gap: 2.5rem;justify-content: center;flex-wrap: wrap;}
        .departments-card {background: linear-gradient(120deg, #e5f2ff 60%, #ffffff 100%);border: none;border-radius: 2rem;box-shadow: 0 8px 32px rgba(34,151,230,0.13), 0 1.5px 0 #d7eaff;padding: 2.3rem 1.7rem 2rem 1.7rem;min-width: 270px;max-width: 350px;text-align: center;display: flex;flex-direction: column;align-items: center;margin-bottom: 2rem;position: relative;transition: transform .18s, box-shadow .18s, filter .18s;z-index: 1;}
        .departments-card:hover {transform: translateY(-8px) scale(1.045) rotate(-0.7deg);filter: brightness(1.04) saturate(1.09);box-shadow: 0 20px 56px rgba(26,75,183,0.19);}
        .departments-card .depart-icon {font-size: 2.7rem;margin-bottom: 1.12rem;background: linear-gradient(120deg,#2297e6 35%, #1a4bb7 90%);border-radius: 50%;color: #fff;padding: 0.7rem;box-shadow: 0 4px 18px #2297e65b;display: inline-block;}
        .departments-card h4 {margin-bottom: 0.7rem;font-size: 1.13rem;font-weight: 800;color: #1763aa;background: none;-webkit-background-clip: unset;-webkit-text-fill-color: unset;}
        .departments-card p {color: #376bad;font-size: 1.06rem;font-weight: 500;line-height: 1.6;}
        .not-hiring-box {background: #fff3f3;border: 1.5px dashed #f5b5b5;padding: 2rem;border-radius: 16px;color: #7a1212;max-width: 1200px;margin: 0 auto;text-align: center;display: flex;flex-direction: column;justify-content: center;align-items: center;}
        .stay-connected {margin-top: 4rem;background: linear-gradient(90deg, #1784e6 0%, #1a4bb7 100%);padding: 2.5rem;border-radius: 28px;color: white;text-align: center;border: none;box-shadow: 0 4px 28px rgba(26,75,183,0.07);}
        .stay-connected h2 {color: #fff !important;background: none !important;-webkit-background-clip: unset !important;-webkit-text-fill-color: unset !important;background-clip: unset !important;}
        .stay-connected a, .stay-btn {display: inline-flex;align-items: center;justify-content: center;background: linear-gradient(90deg, #1784e6 0%, #1a4bb7 100%);color: #fff !important;-webkit-text-fill-color: #fff !important;background-clip: border-box !important;-webkit-background-clip: border-box !important;padding: 0.7rem 1.8rem;border-radius: 10px;font-weight: 700;font-size: 1.15rem;text-decoration: none;margin-top: 1.2rem;border: none;box-shadow: 0 2px 18px rgba(30,100,200,0.09);text-shadow: 0 1px 4px rgba(0,0,0,0.10);transition: background 0.23s, filter 0.2s;}
        .stay-connected a:hover, .stay-btn:hover {filter: brightness(1.09) saturate(1.13);transform: translateY(-2px) scale(1.04);box-shadow: 0 6px 18px rgba(30,100,200,0.17);}
        .stay-connected p {color: #f2f5ff;font-size: 1.14rem;font-weight: 500;margin-bottom: 0.8rem;margin-top: 0;}
        .opportunity-card {background: #fff;border-radius: 12px;padding: 1rem;margin-bottom: 1rem;box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);display: flex;gap: 1rem;align-items: flex-start;}
        .opportunity-icon {font-size: 1.8rem;}
        .opportunity-info h4 {font-size: 1rem;margin: 0;}
        .opportunity-info p {font-size: 0.95rem;color: #444;margin-top: 0.3rem;}
        @media (max-width: 900px) {.career-hero-content { flex-direction: column; gap: 2.2rem;} .mass-life-section {padding: 2.3rem 0.5rem;margin-bottom: 2.3rem;} .departments-cards-row { gap: 1.4rem; } .departments-card { min-width: 0; max-width: 97vw; }}
        @media (max-width: 700px) {.life-mass-cards { flex-direction: column; gap: 1.2rem;} .life-mass-photos { flex-direction: column; gap: 1rem;} .life-mass-desc { max-width: 99vw;} .departments-cards-row { flex-direction: column; gap: 1.2rem;} .departments-card { max-width: 99vw; }}
      `}</style>
      <div className="career-page-gradient"
        style={{
          direction: isAr ? "rtl" : "ltr",
          fontFamily: isAr
            ? "'Cairo', 'Tajawal', Arial, sans-serif"
            : "'Inter', 'Poppins', Arial, sans-serif"
        }}
      >
        <div className="career-hero">
          <div className="career-hero-content">
            <div className="career-hero-left">
              <h1>{t.pageTitle}</h1>
              <p>{t.pageSubtitle}</p>
            </div>
            <div className="career-hero-right">
              <img src={Team1} alt="Careers" />
            </div>
          </div>
        </div>
        <div className="career">
          <div className="content-wrapper">
            <div className="mass-life-section" data-aos="fade-up">
              <div className="mass-life-wrapper">
                <h2>{t.lifeTitle}</h2>
                <p>{t.lifeText}</p>
                <div className="life-mass-grid">
                  <div className="life-mass-cards">
                    <div className="life-mass-card">
                      <FaHandsHelping className="glass-icon" />
                      <h4>{t.missionTitle}</h4>
                      <p>{t.missionText}</p>
                    </div>
                    <div className="life-mass-card">
                      <FaBriefcase className="glass-icon" />
                      <h4>{t.valuesTitle}</h4>
                      <p>{t.valuesText}</p>
                    </div>
                  </div>
                  
                </div>
              </div>
            </div>
            <div className="life-section">
              <div className="life-container">
                <div className="life-image-box" data-aos="zoom-in">
                  <div className="image-frame">
                    <img src={Team} alt="Team Culture" />
                  </div>
                </div>
                <div className="life-content">
                  <h3><FaQuoteLeft /> {t.meetTeam}</h3>
                  {t.teamMembers.map((m, i) => (
                    <div key={i} className="quote-card" data-aos="fade-up">
                      <img src={m.img} alt={m.name} />
                      <div>
                        <p>{m.quote}</p>
                        <div className="title">{m.name} — {m.title}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            {/* --- Departments Cards Section --- */}
            <div className="departments-cards-section" data-aos="fade-up">
              <div className="departments-cards-header">{t.departmentsHeader}</div>
              <div className="departments-cards-row">
                {t.departments.map((d, i) => (
                  <div className="departments-card" key={i}>
                    {d.icon}
                    <h4>{d.title}</h4>
                    <p>{d.text}</p>
                  </div>
                ))}
              </div>
            </div>
            <div className="status-section">
              <div className="not-hiring-box">
                <h3><FaExclamationTriangle /> {t.notHiring}</h3>
                <p>{t.notHiringText}</p>
              </div>
            </div>
            <br />
            <br />
            <div className="opportunities-column">
              <h3 style={sectionHeaderStyle}>{t.internshipsHeader}</h3>
              {t.internships.map((intern, i) => (
                <div className="opportunity-card" key={i}>
                  {intern.icon}
                  <div className="opportunity-info">
                    <h4>{intern.title}</h4>
                    <p>{intern.text}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="stay-connected" data-aos="fade-up">
              <h2>{t.stayConnected}</h2>
              <p>{t.stayConnectedText}</p>
              <a
                href="https://www.linkedin.com/company/mass-smartsolutions/"
                target="_blank"
                rel="noopener noreferrer"
                className="stay-btn"
              >
                <FaLinkedin style={{ marginRight: "0.5rem", fontSize: "1.25em" }} />
                {t.followUs}
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CareerPage;
